module.exports = __webpack_public_path__ + "img/no-music.115d5e5f.png";